<template>
  <div class="page-card">
    <h2 class="page-title">发送任务记录</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="keyword"
          clearable
          placeholder="搜索任务名称/任务编号/通知标题"
          style="width: 320px"
        />
        <el-button type="primary" @click="fetchData">刷新</el-button>
      </div>
      <el-button v-if="canCreate" type="primary" @click="$router.push('/ops/message-send')">新建系统通知</el-button>
    </div>

    <el-table :data="filteredList" border>
      <el-table-column prop="taskNo" label="任务编号" width="180" />
      <el-table-column prop="taskName" label="任务名称" min-width="180" />
      <el-table-column label="发送对象" width="120">
        <template slot-scope="{ row }">
          {{ receiverTypeLabel(row.receiverType) }}
        </template>
      </el-table-column>
      <el-table-column label="发送范围" width="120">
        <template slot-scope="{ row }">
          {{ scopeTypeLabel(row.sendScopeType) }}
        </template>
      </el-table-column>
      <el-table-column label="任务状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="taskStatusTagType(row.taskStatus)">
            {{ taskStatusLabel(row.taskStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="messageTitle" label="通知标题" min-width="220" show-overflow-tooltip />
      <el-table-column label="结果" width="140">
        <template slot-scope="{ row }">
          成功 {{ row.successCount || 0 }} / 失败 {{ row.failCount || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="180" />
      <el-table-column prop="actualSendAt" label="发送时间" width="180" />
      <el-table-column label="操作" width="140">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="filteredList.length === 0" class="empty-state">暂无发送任务</div>
  </div>
</template>

<script>
import { hasPermission } from '../../../utils/auth'
import { getAdminMessageTasks } from '../../../api/opsMessage'

export default {
  name: 'OpsMessageTaskListPage',
  data() {
    return {
      keyword: '',
      list: []
    }
  },
  computed: {
    canCreate() {
      return hasPermission('ops_message_task:create')
    },
    filteredList() {
      const keyword = (this.keyword || '').trim().toLowerCase()
      if (!keyword) {
        return this.list
      }
      return this.list.filter(item => {
        return [item.taskNo, item.taskName, item.messageTitle]
          .filter(Boolean)
          .some(text => String(text).toLowerCase().includes(keyword))
      })
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    receiverTypeLabel(type) {
      const map = {
        1: '艺人',
        2: '商家',
        3: '全部'
      }
      return map[Number(type)] || '-'
    },
    scopeTypeLabel(type) {
      return Number(type) === 1 ? '全量' : '-'
    },
    taskStatusLabel(status) {
      const map = {
        2: '待发送',
        3: '发送中',
        4: '已完成',
        5: '部分失败'
      }
      return map[Number(status)] || '处理中'
    },
    taskStatusTagType(status) {
      const map = {
        2: 'info',
        3: 'warning',
        4: 'success',
        5: 'danger'
      }
      return map[Number(status)] || 'info'
    },
    async fetchData() {
      const data = await getAdminMessageTasks().catch(() => [])
      this.list = Array.isArray(data) ? data : []
    },
    openDetail(row) {
      this.$router.push(`/ops/message-tasks/${row.id}`)
    }
  }
}
</script>

<style scoped>
.empty-state {
  padding: 24px 0 4px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
</style>

